<template>
  <div class="title-content">
    <div v-if="hasImgTitles.includes(title)" class="title-img">
      <img 
        :src="`/static/img/menu/${title}.png`" 
        :alt="title"
        :style="`filter: drop-shadow(${color} 0 40px); -webkit-filter: drop-shadow(${color} 0 40px)`">
    </div>
    <div v-else class="title-inner-text" :style="{color: color}">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    color: {
      type: String,
      default: '#643D20',
    }
  },
  data() {
    return {
      // 有图片的title
      // hasImgTitles: ["中心动态", "名家讲坛", "文化交流", "文化要闻", "理事介绍", "理事会架构", "理事风采", "简介", "章程", "友情链接", "搜索", "搜索结果", "理事名作" ],
      hasImgTitles: [],
    }
  },
}
</script>

<style lang="less" scoped>
.title-content {
  .title-img {
    height: 28px;
    overflow: hidden;
    img {
      height: 100%;
      position: relative;
      top: -40px;
      overflow: hidden;
      // filter: drop-shadow(rgb(255,255,0) 0 40px);
    }
  }
  .title-inner-text {
    font-size: 26px;
    color: @themeColor2;
    letter-spacing: 1px;
    font-family: xingkai;
  }
}
@media screen and (max-width: @xsW) {
  
}
</style>
